import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';

import SimpleHeader from '../../../headers/simpleHeader';

const LinkHeader = ({ heading, label, link }) => (
  <SimpleHeader
    heading={heading}
  >
    <div className="u-height-full o-flexbox o-flexbox--content-align-center u-pr">
      <Link
        to={link}
        className="c-btn c-btn--grey u-width-120 u-mr-- c-btn--medium u-mr0"
      >
        <span className="c-btn__text">{label}</span>
      </Link>
    </div>
  </SimpleHeader>
);

LinkHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default LinkHeader;
